"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SymbolNodeDependencies = void 0;

var _dependenciesUnitClassGenerated = require("./dependenciesUnitClass.generated.js");

var _dependenciesNodeGenerated = require("./dependenciesNode.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var SymbolNodeDependencies = {
  UnitDependencies: _dependenciesUnitClassGenerated.UnitDependencies,
  NodeDependencies: _dependenciesNodeGenerated.NodeDependencies,
  createSymbolNode: _factoriesAny.createSymbolNode
};
exports.SymbolNodeDependencies = SymbolNodeDependencies;